import { render, staticRenderFns } from "./VagalManeuverCheck.vue?vue&type=template&id=031db351&scoped=true&"
import script from "./VagalManeuverCheck.vue?vue&type=script&lang=js&"
export * from "./VagalManeuverCheck.vue?vue&type=script&lang=js&"
import style0 from "./VagalManeuverCheck.vue?vue&type=style&index=0&id=031db351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031db351",
  null
  
)

export default component.exports